/*

Jelly.Connections.Eventbrite_Get_Variable = function (Parameters) {
	// Find string position
	var Variable_Occurrence = Parameters.Content.indexOf(Parameters.Variable);
	// Get next two positions of '
	var Variable_Start = Parameters.Content.indexOf("'", Variable_Occurrence);
	var Variable_End = Parameters.Content.indexOf("'", Variable_Start);
	
	// Get characters in between and return
	return Parameters.Content.substring(Variable_Start + 1, Variable_End);
}

Jelly.Connections.Setup_Eventbrite = function (Parameters) {
	var Eventbrite_URL = 'https://www.eventbriteapi.com/v3/events/' + Parameters.Event_ID + '/ticket_classes?token=' + Parameters.Token;
	var Eventbrite_Ticket_ID = null;
	var Eventbrite_Available_Stock = null;

	// Get ticket ID & remaining tickets
	$.getJSON(Eventbrite_URL, null, function (data) { 
		$.each(data.ticket_classes, function (key, Eventbrite_Ticket) {
			if (Eventbrite_Ticket.on_sale_status == "AVAILABLE") {	
				Eventbrite_Ticket_ID = Eventbrite_Ticket.id;
				Eventbrite_Available_Stock = Eventbrite_Ticket.quantity_total - Eventbrite_Ticket.quantity_sold
				return false;
			}
		})
	});	
	
	// Create new order
	var Eventbrite_Order_Starter_URL = 'https://www.eventbrite.com/tickets-external?eid=' + Parameters.Event_ID + '&ref=etckt';
	console.log(Eventbrite_Order_Starter_URL);
	var Eventbrite_Order_Starter_HTML = $.get(Eventbrite_Order_Starter_URL, null, function (data) {
		console.log("IN");
		Jelly.Connections.Order_Start_UUID = Jelly.Connections.Eventbrite_Get_Variable({
				Content: Eventbrite_Order_Starter_HTML
			,	Variable: 'orderStartUuid'
		});
		Jelly.Connections.Order_Start_Signature = Jelly.Connections.Eventbrite_Get_Variable({
				Content: Eventbrite_Order_Starter_HTML
			,	Variable: 'orderStartSginature'
		});
	});

*/

Jelly.Connections.Continue_To_Eventbrite = function (Parameters) {	

	// Parameters: Event ID, Promo Code

	// Show disclaimer
	Jelly.Interface.Create_Window({
				Alias: 'Eventbrite_Redirect_Disclaimer'			
			,	URL: '/Block/Eventbrite_Redirect_Disclaimer'
		});

	// Create a full-screen overlay container
	var overlay = document.createElement('div');
	overlay.classList.add('eventbrite-fullscreen-overlay');

	// If a promo code is supplied, add a message above the iframe container
	if (Parameters.Promo_Code) {
		var promoDiv = document.createElement('div');
		promoDiv.classList.add('eventbrite-promo-banner');

		// Text part 1: "Thank you for being a member! Please copy and enter this promo code below: "
		var textPart1 = document.createElement('span');
		textPart1.innerHTML = 'Thank you for being a member! Please copy and enter this promo code below:&nbsp;';
		textPart1.classList.add('eventbrite-promo-text-spacing');

		// Promo code display (bold)
		var promoCodeStrong = document.createElement('strong');
		promoCodeStrong.textContent = Parameters.Promo_Code;
		promoCodeStrong.classList.add('eventbrite-promo-code-display');

		// Copy button
		var copyButton = document.createElement('button');
		copyButton.textContent = 'Copy';
		copyButton.setAttribute('type', 'button');
		copyButton.classList.add('eventbrite-copy-button');

		copyButton.onclick = function() {
			// Remove previous status classes
			copyButton.classList.remove('copied', 'failed', 'no-clipboard');

			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(Parameters.Promo_Code).then(function() {
					copyButton.textContent = 'Copied!';
					copyButton.classList.add('copied');
					copyButton.disabled = true;
					setTimeout(function() {
						copyButton.textContent = 'Copy';
						copyButton.classList.remove('copied');
						copyButton.disabled = false;
					}, 2000);
				}).catch(function(err) {
					console.error('Jelly.Connections.Eventbrite_Connect: Could not copy promo code: ', err);
					copyButton.textContent = 'Failed';
					copyButton.classList.add('failed');
					copyButton.disabled = true;
					setTimeout(function() {
						copyButton.textContent = 'Copy';
						copyButton.classList.remove('failed');
						copyButton.disabled = false;
					}, 3000);
				});
			} else {
				console.warn('Jelly.Connections.Eventbrite_Connect: navigator.clipboard.writeText not available.');
				copyButton.textContent = 'No Clipboard API';
				copyButton.classList.add('no-clipboard');
				copyButton.disabled = true;
			}
		};

		// Append elements to promoDiv
		promoDiv.appendChild(textPart1);
		promoDiv.appendChild(promoCodeStrong);
		promoDiv.appendChild(copyButton);

		overlay.appendChild(promoDiv);
	}

	// Create the inner iframe container
	var iframeContainer = document.createElement('div');
	iframeContainer.id = 'eventbrite_inner_iframe_container'; // ID is used by EBWidget
	iframeContainer.classList.add('eventbrite-iframe-wrapper');
	overlay.appendChild(iframeContainer);

	// Add overlay to the body
	document.body.appendChild(overlay);

	// INSERT_YOUR_CODE

	// Create a loading screen element
	var loadingScreen = document.createElement('div');
	loadingScreen.id = 'eventbrite_loading_screen'; // ID can be used for specific targeting if needed
	loadingScreen.classList.add('eventbrite-loading-overlay');

	// Add a spinner
	var spinner = document.createElement('div');
	spinner.classList.add('eventbrite-spinner');
	loadingScreen.appendChild(spinner);

	// Add loading text
	var loadingText = document.createElement('div');
	loadingText.innerText = 'Loading Eventbrite checkout ...';
	loadingText.classList.add('eventbrite-loading-text');
	loadingScreen.appendChild(loadingText);

	// Keyframes for spinner animation are now in Withfriends.less, so no need to add style element here for that.

	// Append loading screen to the overlay
	overlay.appendChild(loadingScreen);

	// Remove loading screen when iframe loads
	var observer = new MutationObserver(function(mutations) {
		var iframe = iframeContainer.querySelector('iframe');
		if (iframe) {
			var loaderRemoved = false;
			var removeLoader = function() {
				if (!loaderRemoved && loadingScreen && loadingScreen.parentNode) {
					loadingScreen.parentNode.removeChild(loadingScreen);
					loaderRemoved = true;
				}
			};

			// Fallback: Remove loader on iframe load event
			iframe.addEventListener('load', function() {
				removeLoader();
				if (contentCheckInterval) {
					clearInterval(contentCheckInterval);
				}
			});

			// Periodically check if iframe has content
			var contentCheckInterval = setInterval(function() {
				try {
					if (iframe.contentWindow && 
						iframe.contentWindow.document && 
						iframe.contentWindow.document.readyState === 'complete' &&
						iframe.offsetWidth > 0 && 
						iframe.offsetHeight > 0
					) {
						// Add a 500ms delay before removing the loader
						setTimeout(function() {
							removeLoader();
						}, 1000);
						clearInterval(contentCheckInterval);
					}
				} catch (e) {
					// Cross-origin access error, likely means content is not yet accessible or loaded
					// We'll rely on the 'load' event in this case.
				}
			}, 200); // Check every 200ms

			observer.disconnect();
		}
	});
	observer.observe(iframeContainer, { childList: true });

	const widgetParameters = {
		widgetType: 'checkout',
		eventId: Parameters.Event_ID,
		iframeContainerId: 'eventbrite_inner_iframe_container',
		iframeContainerHeight: window.innerHeight
	}
	if (Parameters.Ticket_Cap){
		widgetParameters.onTicketQuantityChange =  function(data){
			if (data.quantity > Parameters.Ticket_Cap) {
				alert('Please limit your order to ' + Parameters.Ticket_Cap + ' tickets for this event, or we may have to cancel and refund this order.  \r\n\r\nTo order tickets past your guest limit, make a second order after this one for regular price tickets.\r\n\r\n Thank you.');
			}
		};
	}

	// Pass the EB widget code with the inner iframe container
	window.EBWidgets.createWidget(widgetParameters);
}